import { isNotExpiredLogin } from './userService';

export function dateToISO8601String(date) {
  const now = date || new Date();
  const tzo = -now.getTimezoneOffset();
  const dif = tzo >= 0 ? '+' : '-';
  const pad = num => {
    const norm = Math.abs(Math.floor(num));
    return (norm < 10 ? '0' : '') + norm;
  };
  const newDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
    .toISOString()
    .replace(/Z$/, '');
  const newPad = `${pad(tzo / 60)}:${pad(tzo % 60)}`;

  return `${newDate}${dif}${newPad}`;
}

export function dateToShowFormat(date) {
  const nDate = new Date(date);
  let m = nDate.getMonth() + 1;
  let min = nDate.getMinutes();
  if (m.toString().length === 1) {
    m = `0${m}`;
  }
  if (min.toString().length === 1) {
    min = `0${nDate.getMinutes()}`;
  }
  return `${nDate.getDate()}/${m}/${nDate.getFullYear()}, ${nDate.getHours()}:${min}`;
}

export function IsValidResponseStatus(status, fn) {
  return isNotExpiredLogin(status, fn) && !(status === 404 || status === 401);
}

// check locale
export function returnLocaleText(t1, t2) {
  if (typeof t1 === 'undefined') {
    return t2;
  }
  return t1;
}



// WEBPACK FOOTER //
// ./src/service/util.js